export function UserButton() {
  return (
    <button
      type="button"
      aria-label="Open account"
      className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-700 shadow-sm hover:bg-slate-200"
    >
      <span className="text-sm font-semibold">A</span>
    </button>
  );
}
